import { useStore } from '@ozdao/martyrs/modules/core/client';

export function getStore() {
  return useStore();
}

export { useStore };

export default useStore();
